import store from '../store/index.js';
import { falsy } from '../helpers/utils/falsy';

function init(container) {
  const tickerGroups = container.querySelectorAll('.js-quantity-ticker-group');

  if (tickerGroups.length > 0) {
    tickerGroups.forEach((tickerGroup) => {
      const groupTarget = container.querySelector(tickerGroup.dataset.target);
      const tickers = tickerGroup.querySelectorAll('.js-quantity-ticker');
      const defaultValue = container.querySelector('input[name=defaultValue]');

      if (tickers.length > 0) {
        tickers.forEach((ticker) => {


          const input = ticker.querySelector('.quantity__field input');
          const buttonUp = ticker.querySelector('.quantity__field .quantity__button--up');
          const buttonDown = ticker.querySelector('.quantity__field .quantity__button--down');
          const buttons = [buttonUp, buttonDown];

          const identifier = input.id;

          if (buttons.length > 0 && input !== null) {
            const minimum = parseInt(input.dataset.minimum, 10);
            // const itemValue = parseInt(input.dataset.itemValue);

            // Handle button clicks
            buttons.forEach((button) => {
              button.addEventListener('click', (e) => {
                e.preventDefault();

                const current = parseInt(input.value, 10);
                const type = button.dataset.quantity;
                const isBelowZero = (type === '-' && current === 1);

                if (!isBelowZero) {
                  const step = parseInt(type + input.dataset.step, 10);
                  const value = getValue(current, minimum, step, type);
                  store.commit('storeTicker', { [identifier]: { value } });
                }

                const event = new Event('quantityChange');
                document.dispatchEvent(event);

                triggerCartButton();
              });
            });

            // Handle direct input
            input.addEventListener('change', (e) => {
              let newValue = parseInt(e.target.value, 10);
              
              // Validate the input value
              if (isNaN(newValue) || newValue < minimum) {
                newValue = minimum;
              }
              
              // Update the store with the new value
              store.commit('storeTicker', { [identifier]: { value: newValue } });
              
              const event = new Event('quantityChange');
              document.dispatchEvent(event);
              
              triggerCartButton();
            });

            store.subscribe((state) => {
              const { value } = state.tickers[identifier];

              input.value = value;
              input.setAttribute('value', value);

              if (groupTarget !== null) {
                groupTarget.innerHTML = getTargetValue(state.tickers, identifier, defaultValue.value);
              }

              setMinValue(state.tickers, identifier);

              if (value <= minimum) {
                disableButton(buttonDown);
              } else {
                enableButton(buttonDown);
              }
            });

            store.commit('storeTicker', { [identifier]: { value: parseInt(input.value, 10) } });
          }
        });
      }
    });
  }
}

function getTargetValue(tickers, identifier, inputValue) {
  const currency = '£';
  const itemValue = inputValue;
  let quantity = 0;
  let total = 0;
  let string = '';

  for (const [key, value] of Object.entries(tickers)) {
    if (key === identifier) {
      quantity = value.value;
      total = parseFloat(quantity * itemValue).toFixed(2);
    }
  }

  if (quantity > 0) {
    string += ` — ${currency}${total}`;
  }

  return (string !== '') ? string : '';
}

function setMinValue(tickers, identifier) {
  for (const [key, value] of Object.entries(tickers)) {
    if ((key === identifier) && value.value === 0) {
      store.dispatch('storeTicker', { identifier: { value: 1 } });
    }
  }
}

function disableButton(button) {
  button.classList.add('is-inactive');
}

function enableButton(button) {
  button.classList.remove('is-inactive');
}

function getValue(current, minimum, step, type) {
  let value;

  if (current + step > minimum) {
    value = current + step;
  } else if (current + step < minimum) {
    value = (type === '+') ? minimum : 0;
  } else if (current + step === minimum) {
    value = minimum;
  } else if (current + step <= 0) {
    value = 0;
  }

  return value;
}

function triggerCartButton() {
  const updateBtn = document.querySelector('[name=update_cart]');

  if (updateBtn !== null) {
    updateBtn.ariaDisabled = false;
    updateBtn.disabled = false;
  }

}

export function initTickers() {
  init(document);
}
